import React, { ReactElement } from "react";
import { FreightRail } from "../../../types/ICompAnalysisQMD";

interface RouteOtherDetailsProps {
  freight: FreightRail;
}

const RailFreightRouteDetails: React.FC<RouteOtherDetailsProps> = ({
  freight,
}: RouteOtherDetailsProps): ReactElement | null => {
  return (
    <div className="route-details-meta-container">
      {/* route details sub-section */}
      <div className="route-details-container">
        <div className="route-details-box">
          <div className="route-details-text-column">
            <span className="route-details-header-text-left">Car Owner</span>
            <span className="route-details-value-text-left">
              {freight.carOwner}
            </span>
          </div>
          <div className="route-details-text-column">
            <span className="route-details-header-text-right">
              Min Rail Cars
            </span>
            <span className="route-details-value-text-right">
              {freight.minCars}
            </span>
          </div>
        </div>

        <div className="route-details-box">
          <div className="route-details-text-column">
            <span className="route-details-header-text-left">Rule 11</span>
            <span className="route-details-value-text-left">
              {freight.legs.length !== 1 ? "Yes" : "No"}
            </span>
          </div>
          <div className="route-details-text-column">
            <span className="route-details-header-text-right">Exp Date</span>
            <span className="route-details-value-text-right">{`${freight.expiration.month}/${freight.expiration.day}/${freight.expiration.year}`}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RailFreightRouteDetails;
